import React from 'react';
import { useResponsive } from '@sg/garnish';

import { useLocalizationContext } from '@order/Localization';

import { CreditCardFormContent, useCreditCardHandlers } from '../CreditCard';
import { Modal } from '../Modal';

export const CreditCardAddModal = (props: CreditCardAddModalProps) => {
  const { visible, onComplete, onRequestClose } = props;

  const { t } = useLocalizationContext();
  const { match } = useResponsive();

  const { isSubmitting, handleOnSave } = useCreditCardHandlers({
    onComplete: onComplete ?? onRequestClose,
  });

  return (
    <Modal
      fitHeight
      visible={visible}
      accessibilityLabel={t('credit-card-form.add')}
      presentationStyle="pageSheet"
      size={match(['full', 'small'])}
      onRequestClose={onRequestClose}
    >
      <Modal.Header onClose={onRequestClose}>
        {t('credit-card-form.add')}
      </Modal.Header>

      <CreditCardFormContent
        isVisible
        vault="order"
        mode="add"
        isSaving={isSubmitting}
        onSave={handleOnSave}
      />
    </Modal>
  );
};

// ─── Types ─────────────────────────────────────────────────────────────

type CreditCardAddModalProps = {
  readonly visible: boolean;
  readonly onRequestClose: () => void;
  readonly onComplete?: () => void;
};
